<template>
   <center>
      <link rel="stylesheet" href="https://api.systempay.fr/static/js/krypton-client/V4.0/ext/classic-reset.css">

      <div v-show="showPayment">
         <transition name="fade">

            <v-card data-app="true">
               <v-card-title>
                  {{ $t('titles.payment_by_card') }}
                  <v-spacer></v-spacer>
                  <v-icon @click="onClose">mdi-close</v-icon>
               </v-card-title>
               <v-card-text>
                  <div id="paymentForm" class="kr-embedded">

                        <div class="kr-pan"></div>
                        <div class="kr-expiry"></div>
                        <div class="kr-security-code"></div>      
                        
                        <button class="kr-payment-button"></button>

                        <div class="kr-form-error"></div>
                  </div>
               </v-card-text>
            </v-card>

         </transition>
      </div>

   </center>
</template>

<script>
   import i18n from '@/plugins/i18n.js';
   import BasicComponent from '@/views/BasicComponent.vue';

   export default {
      name: "ddoSystemPay",
      mixins: [BasicComponent],

      data: function () {
         return {
            pay_infos: null,
            pay_pk: null,
            showPayment: true,
            paymentScript: null,
            formToken: null,
            promiseError: '',

         }
      },

      props: {
         amount: {type: Number, default: 0 },
      },

      mounted() {
         this.append_script_to_head();
         console.log('ddoSystemPay::mounted()');
      },

      methods: {

         append_script_to_head() {
            if ( this.paymentScript==null ) {
               this.paymentScript = document.createElement('script');
               this.paymentScript.setAttribute('kr-public-key','90130178:testpublickey_Wp2wohNZKdAthNFBK32y2PF1pnq6IwZVNpZcBbGOmrOYi');
               this.paymentScript.setAttribute('src','https://api.systempay.fr/static/js/krypton-client/V4.0/stable/kr-payment-form.min.js');
               document.head.appendChild(this.paymentScript);
               //console.log('append_script_to_head()');
            }
         },

         async update_payment(row) {
            this.loading = true;
            await this.$api.updateRow(this.$router,'payment',row.pay_pk,row,'payment_by_card');
            this.loading = false;
         },

         async display_payment(infos) {
            this.formToken = null;
            this.pay_infos = infos;
            this.pay_pk = null;
            console.log("ddoSystemPay::display_payment, infos="+JSON.stringify(infos))
            var { errorinfos, api_response } = await this.create_payment_token(infos);
            console.log("ddoSystemPay::display_payment, api_response="+JSON.stringify(api_response))
            if ( api_response.error==0 && api_response.pay_formtoken ) {
               this.pay_pk = api_response._pk;
               this.formToken = api_response.pay_formtoken;
               KR.setFormToken(this.formToken);
               KR.onSubmit(this.onPaid);
               KR.onFocus(this.onFocus);
               KR.onFormCreated(this.onFormCreated);
               KR.onFormReady(this.onFormReady);
               this.showPayment = true;
            }
            return { errorinfos, api_response }
         },

         async create_payment_token(infos) {
            this.loading = true;
            var { errorinfos, api_response } = await this.$api.createRow(this.$router,'payment',infos);
            this.loading = false;
            return { errorinfos, api_response }
         },

         onFormCreated() {
            console.log('onFormCreated');
         },

         onFormReady(event) {
            console.log('onFormReady');
         },

         onFocus(event) {
            console.log('onFocus, field='+event.field);
         },

         onError(event) {
            console.log('onError, errorMessage='+event.errorMessage);
         },

         onClose() {
            console.log('onClose');
            KR.removeForms();
            this.showPayment = false;
            this.$emit('onClose');
         },

         inform_of_payment() {

         },

         async onPaid(event) {
            console.log('Paid !, clientAnswer='+JSON.stringify(event.clientAnswer));
            if (event.clientAnswer.orderStatus === "PAID") {
               if ( this.pay_pk!=null ) {
                  var row = { pay_pk: this.pay_pk, pay_gw_status : event.clientAnswer.orderStatus }
                  //var { errorinfos, api_response } = await this.update_payment(row);
               }
               // Remove the payment form
               KR.removeForms();
               this.showPayment = false;
            } else {
               // Show error message to the user
               alert("Payment failed !");
            }
            this.$emit('onPaid',event)         
         },

      },

    }
</script>